export default {
    risk_exposure_2005: 'Diabetes mellitus',
    risk_exposure_2427: 'Diet low in calcium (g/day)',
    risk_exposure_2428: 'Diet low in fiber (g/day)',
    risk_exposure_2429: 'Diet low in seafood omega-3 fatty acids (g/day)',
    risk_exposure_2430: 'Diet low in fruits (g/day)',
    risk_exposure_2431: 'Diet low in whole grains (g/day)',
    risk_exposure_2432: 'Diet low in legumes (g/day)',
    risk_exposure_2433: 'Diet low in milk (g/day)',
    risk_exposure_2434: 'Diet low in nuts and seeds (g/day)',
    risk_exposure_2435: 'Diet high in processed meat (g/day)',
    risk_exposure_2436: 'Diet low in polyunsaturated fatty acids (% energy/day)',
    risk_exposure_2437: 'Diet high in red meat (g/day)',
    risk_exposure_2438: 'Diet high in sodium (g/day)',
    risk_exposure_2441: 'Diet high in trans fatty acids (% energy/day)',
    risk_exposure_2442: 'Diet low in vegetables (g/day)',
    risk_exposure_2443: 'Low bone mineral density mean',
    risk_exposure_2444: 'Low bone mineral density standard deviation',
    risk_exposure_2452: 'Intimate partner violence',
    risk_exposure_2453: 'Fraction of homicide against females due to IPV',
    risk_exposure_2510: 'Vitamin A deficiency',
    risk_exposure_2511: 'Household air pollution from solid fuels',
    risk_exposure_2535: 'Residential radon (Bq/m3)',
    risk_exposure_2540: 'Severe Underweight, < -3 SD (post-ensemble)',
    risk_exposure_2541: 'Underweight Between -3 SD and -2 SD (post-ensemble)',
    risk_exposure_2542: 'Underweight Between -2 SD and -1 SD (post-ensemble)',
    risk_exposure_2544: 'Zinc deficiency',
    risk_exposure_2547: 'Systolic blood pressure level',
    risk_exposure_2548: 'Body-mass index level (Adults)',
    risk_exposure_2636: 'Proportion HIV due to commercial sex work',
    risk_exposure_2637: 'Proportion HIV due to intravenous drug use',
    risk_exposure_2638: 'Proportion HIV due to sex',
    risk_exposure_2639: 'Proportion HIV due to other',
    risk_exposure_2787: 'Intravenous drug use',
    risk_exposure_3053: 'Male childhood sexual abuse',
    risk_exposure_3054: 'Female childhood sexual abuse',
    risk_exposure_3360: 'Alcohol Consumption (g/day)',
    risk_exposure_8869: 'Unsafe water exposure, Unimproved & chlorinated',
    risk_exposure_8870: 'Unsafe water exposure, Unimproved & filtered',
    risk_exposure_8871: 'Unsafe water exposure, Improved & untreated',
    risk_exposure_8872: 'Unsafe water exposure, Improved & chlorinated',
    risk_exposure_8873: 'Unsafe water exposure, Improved & filtered',
    risk_exposure_8874: 'Unsafe water exposure, Piped & untreated',
    risk_exposure_8875: 'Unsafe water exposure, Piped & chlorinated',
    risk_exposure_8877: 'Unsafe water exposure, High quality piped & untreated',
    risk_exposure_8878: 'Unsafe water exposure, High quality piped & chlorinated',
    risk_exposure_8879: 'Unsafe sanitation exposure, Improved',
    risk_exposure_8881: 'Ambient ozone pollution exposure',
    risk_exposure_8882: 'Iron deficiency exposure',
    risk_exposure_8883: 'Occupational asthmagens exposure, Admin',
    risk_exposure_8884: 'Occupational asthmagens exposure, Technical',
    risk_exposure_8885: 'Occupational asthmagens exposure, Sales',
    risk_exposure_8886: 'Occupational asthmagens exposure, Agriculture',
    risk_exposure_8887: 'Occupational asthmagens exposure, Mining',
    risk_exposure_8888: 'Occupational asthmagens exposure, Transport',
    risk_exposure_8889: 'Occupational asthmagens exposure, Manufact',
    risk_exposure_8890: 'Occupational asthmagens exposure, Services',
    risk_exposure_8892: 'Occupational particulate matter, gases, and fumes exposure, High',
    risk_exposure_8893: 'Occupational particulate matter, gases, and fumes exposure, Low',
    risk_exposure_8894: 'Occupational noise exposure, High exposure (>90dB)',
    risk_exposure_8895: 'Occupational noise exposure, Low exposure (85-90dB)',
    risk_exposure_8897:
        'Occupational ergonomic factors exposure, Professional, technical and related workers',
    risk_exposure_8898:
        'Occupational ergonomic factors exposure, Administrative and managerial workers',
    risk_exposure_8899: 'Occupational ergonomic factors exposure, Clerical and related workers',
    risk_exposure_8900: 'Occupational ergonomic factors exposure, Sales workers',
    risk_exposure_8901: 'Occupational ergonomic factors exposure, Service workers',
    risk_exposure_8902:
        'Occupational ergonomic factors exposure, Agriculture, animal husbandry and forestry workers, fishermen and hunters',
    risk_exposure_8903:
        'Occupational ergonomic factors exposure, Production and related workers, transport equipment operators and labourers',
    risk_exposure_8904: 'Non-exclusive breastfeeding exposure, partial',
    risk_exposure_8905: 'Non-exclusive breastfeeding exposure, predominant',
    risk_exposure_8907: 'Discontinued breastfeeding exposure',
    risk_exposure_8909: 'High fasting plasma glucose (continuous) exposure',
    risk_exposure_8916: 'Occupational exposure to arsenic exposure, High exposure',
    risk_exposure_8917: 'Occupational exposure to arsenic exposure, Low exposure',
    risk_exposure_8918: 'Occupational exposure to benzene exposure, High exposure',
    risk_exposure_8919: 'Occupational exposure to benzene exposure, Low exposure',
    risk_exposure_8920: 'Occupational exposure to beryllium exposure, High exposure',
    risk_exposure_8921: 'Occupational exposure to beryllium exposure, Low exposure',
    risk_exposure_8922: 'Occupational exposure to cadmium exposure, High exposure',
    risk_exposure_8923: 'Occupational exposure to cadmium exposure, Low exposure',
    risk_exposure_8924: 'Occupational exposure to chromium exposure, High exposure',
    risk_exposure_8925: 'Occupational exposure to chromium exposure, Low exposure',
    risk_exposure_8926: 'Occupational exposure to diesel engine exhaust exposure, High exposure',
    risk_exposure_8927: 'Occupational exposure to diesel engine exhaust exposure, Low exposure',
    risk_exposure_8930: 'Occupational exposure to formaldehyde exposure, High exposure',
    risk_exposure_8931: 'Occupational exposure to formaldehyde exposure, Low exposure',
    risk_exposure_8932: 'Occupational exposure to nickel exposure, High exposure',
    risk_exposure_8933: 'Occupational exposure to nickel exposure, Low exposure',
    risk_exposure_8934:
        'Occupational exposure to polycyclic aromatic hydrocarbons exposure, High exposure',
    risk_exposure_8935:
        'Occupational exposure to polycyclic aromatic hydrocarbons exposure, Low exposure',
    risk_exposure_8936: 'Occupational exposure to silica exposure, High exposure',
    risk_exposure_8937: 'Occupational exposure to silica exposure, Low exposure',
    risk_exposure_8938: 'Occupational exposure to sulfuric acid exposure, High exposure',
    risk_exposure_8939: 'Occupational exposure to sulfuric acid exposure, Low exposure',
    risk_exposure_8942: 'Occupational exposure to trichloroethylene exposure, High exposure',
    risk_exposure_8943: 'Occupational exposure to trichloroethylene exposure, Low exposure',
    risk_exposure_8944: 'No access to handwashing facility exposure',
    risk_exposure_8945: 'Severe Wasting, < -3 SD (post-ensemble)',
    risk_exposure_8946: 'Wasting Between -3 SD and -2 SD (post-ensemble)',
    risk_exposure_8947: 'Wasting Between -2 SD and -1 SD (post-ensemble)',
    risk_exposure_8949: 'Severe Stunting, < -3 SD (post-ensemble)',
    risk_exposure_8950: 'Stunting Between -3 SD and -2 SD (post-ensemble)',
    risk_exposure_8951: 'Stunting Between -2 SD and -1 SD (post-ensemble)',
    risk_exposure_8953: 'Lead exposure in blood exposure',
    risk_exposure_8954: 'Lead exposure in bone exposure',
    risk_exposure_9369: 'Unsafe sanitation exposure, Unimproved & untreated',
    risk_exposure_9415: 'Unsafe water exposure, Unimproved & untreated',
    risk_exposure_9598: 'Non-exclusive breastfeeding exposure, none',
    risk_exposure_9804: 'unadjusted sugar-sweetened beverages',
    risk_exposure_10345: 'Prevalence of obesity (Children)',
    risk_exposure_10509: 'Stage 1-2 chronic kidney disease',
    risk_exposure_10620: 'Smokeless tobacco',
    risk_exposure_10729: 'Physical activity (METs)',
    risk_exposure_10732: 'Stage 3 chronic kidney disease squeezed',
    risk_exposure_10733: 'Stage 4 chronic kidney disease squeezed',
    risk_exposure_10734: 'Stage 5 chronic kidney disease squeezed',
    risk_exposure_10755: 'Birth prevalence - [0, 24) wks, [0, 500) g',
    risk_exposure_10761: 'Birth prevalence - [0, 24) wks, [500, 1000) g',
    risk_exposure_10763: 'Birth prevalence - [24, 26) wks, [500, 1000) g',
    risk_exposure_10764: 'Birth prevalence - [26, 28) wks, [500, 1000) g',
    risk_exposure_10767: 'Birth prevalence - [30, 32) wks, [500, 1000) g',
    risk_exposure_10768: 'Birth prevalence - [28, 30) wks, [500, 1000) g',
    risk_exposure_10770: 'Birth prevalence - [26, 28) wks, [1000, 1500) g',
    risk_exposure_10772: 'Birth prevalence - [34, 36) wks, [1000, 1500) g',
    risk_exposure_10773: 'Birth prevalence - [28, 30) wks, [1500, 2000) g',
    risk_exposure_10774: 'Birth prevalence - [28, 30) wks, [1000, 1500) g',
    risk_exposure_10775: 'Birth prevalence - [32, 34) wks, [1000, 1500) g',
    risk_exposure_10776: 'Birth prevalence - [30, 32) wks, [1000, 1500) g',
    risk_exposure_10777: 'Birth prevalence - [37, 38) wks, [1500, 2000) g',
    risk_exposure_10778: 'Birth prevalence - [36, 37) wks, [1500, 2000) g',
    risk_exposure_10779: 'Birth prevalence - [30, 32) wks, [2000, 2500) g',
    risk_exposure_10780: 'Birth prevalence - [30, 32) wks, [1500, 2000) g',
    risk_exposure_10781: 'Birth prevalence - [34, 36) wks, [1500, 2000) g',
    risk_exposure_10782: 'Birth prevalence - [32, 34) wks, [1500, 2000) g',
    risk_exposure_10783: 'Birth prevalence - [32, 34) wks, [2000, 2500) g',
    risk_exposure_10784: 'Birth prevalence - [40, 42) wks, [2000, 2500) g',
    risk_exposure_10785: 'Birth prevalence - [38, 40) wks, [2000, 2500) g',
    risk_exposure_10786: 'Birth prevalence - [32, 34) wks, [2500, 3000) g',
    risk_exposure_10787: 'Birth prevalence - [34, 36) wks, [2000, 2500) g',
    risk_exposure_10788: 'Birth prevalence - [37, 38) wks, [2000, 2500) g',
    risk_exposure_10789: 'Birth prevalence - [36, 37) wks, [2000, 2500) g',
    risk_exposure_10790: 'Birth prevalence - [34, 36) wks, [2500, 3000) g',
    risk_exposure_10791: 'Birth prevalence - [34, 36) wks, [4000, 4500) g',
    risk_exposure_10792: 'Birth prevalence - [34, 36) wks, [3000, 3500) g',
    risk_exposure_10793: 'Birth prevalence - [36, 37) wks, [2500, 3000) g',
    risk_exposure_10794: 'Birth prevalence - [34, 36) wks, [3500, 4000) g',
    risk_exposure_10795: 'Birth prevalence - [37, 38) wks, [2500, 3000) g',
    risk_exposure_10796: 'Birth prevalence - [40, 42) wks, [2500, 3000) g',
    risk_exposure_10797: 'Birth prevalence - [38, 40) wks, [2500, 3000) g',
    risk_exposure_10798: 'Birth prevalence - [36, 37) wks, [3000, 3500) g',
    risk_exposure_10799: 'Birth prevalence - [36, 37) wks, [4000, 4500) g',
    risk_exposure_10800: 'Birth prevalence - [36, 37) wks, [3500, 4000) g',
    risk_exposure_10801: 'Birth prevalence - [37, 38) wks, [3000, 3500) g',
    risk_exposure_10802: 'Birth prevalence - [37, 38) wks, [4000, 4500) g',
    risk_exposure_10803: 'Birth prevalence - [37, 38) wks, [3500, 4000) g',
    risk_exposure_10804: 'Birth prevalence - [40, 42) wks, [3000, 3500) g',
    risk_exposure_10805: 'Birth prevalence - [38, 40) wks, [3000, 3500) g',
    risk_exposure_10806: 'Birth prevalence - [38, 40) wks, [4000, 4500) g',
    risk_exposure_10807: 'Birth prevalence - [38, 40) wks, [3500, 4000) g',
    risk_exposure_10808: 'Birth prevalence - [40, 42) wks, [3500, 4000) g',
    risk_exposure_10809: 'Birth prevalence - [40, 42) wks, [4000, 4500) g',
    risk_exposure_11231: 'Ambient particulate matter pollution population-weighted PM2.5',
    risk_exposure_11264: 'Alchol consumption (g/day)',
    risk_exposure_11522: 'Secondhand smoke exposure',
    risk_exposure_15788: 'Systolic blood pressure level standard deviation',
    risk_exposure_15794: 'Unsafe water exposure, Piped & filtered',
    risk_exposure_16424: 'Occupational exposure to asbestos, Any exposure',
    risk_exposure_16436: 'Intravenous drug use, interpolated annual results',
    risk_exposure_16437: 'Opioid use disorders cases, interpolated annual results',
    risk_exposure_16438: 'Cocaine use disorders cases, interpolated annual results',
    risk_exposure_16439: 'Amphetamine use disorders cases, interpolated annual results',
    risk_exposure_18685: 'Residential radon standard deviation (Bq/m3)',
    risk_exposure_18687: 'Lead exposure in bone standard deviation',
    risk_exposure_18689: 'Diet low in fruits standard deviation (g/day)',
    risk_exposure_18690: 'Diet low in vegetables standard deviation (g/day)',
    risk_exposure_18691: 'Diet low in legumes standard deviation (g/day)',
    risk_exposure_18692: 'Diet low in whole grains standard deviation (g/day)',
    risk_exposure_18693: 'Diet low in nuts and seeds standard deviation (g/day)',
    risk_exposure_18694: 'Diet low in milk standard deviation (g/day)',
    risk_exposure_18695: 'Diet high in red meat standard deviation (g/day)',
    risk_exposure_18696: 'Diet high in processed meat standard deviation (g/day)',
    risk_exposure_18697: 'Diet low in fiber standard deviation (g/day)',
    risk_exposure_18698: 'Diet low in calcium standard deviation (g/day)',
    risk_exposure_18699: 'Diet low in seafood omega-3 fatty acids standard deviation (g/day)',
    risk_exposure_18700:
        'Diet low in polyunsaturated fatty acids standard deviation (% energy/day)',
    risk_exposure_18702: 'Diet high in trans fatty acids standard deviation (% energy/day)',
    risk_exposure_18703: 'Diet high in sodium standard deviation (g/day)',
    risk_exposure_18704: 'Physical activity standard deviation (METs)',
    risk_exposure_18705: 'High fasting plasma glucose standard deviation (mmol/L)',
    risk_exposure_18706: 'Body mass index level standard deviation',
    risk_exposure_18740: 'Bullying victimization exposure',
    risk_exposure_18776: 'Diet high in sugar-sweetened beverages standard deviation (g/day)',
    risk_exposure_18822: 'Low-density lipoprotein (mmol/L)',
    risk_exposure_18823: 'Low-density lipoprotein standard deviation (mmol/L)',
    risk_exposure_19763: 'Prevalence of Current Any Smokers',
    risk_exposure_19766: 'Prevalence of Former Any Smokers',
    risk_exposure_20018: 'Prevalence of overweight only (Children)',
    risk_exposure_20203: 'Birth prevalence - [28, 30) wks, [2000, 2500) g',
    risk_exposure_20204: 'Birth prevalence - [28, 30) wks, [2500, 3000) g',
    risk_exposure_20205: 'Birth prevalence - [28, 30) wks, [3000, 3500) g',
    risk_exposure_20209: 'Birth prevalence - [30, 32) wks, [2500, 3000) g',
    risk_exposure_20210: 'Birth prevalence - [30, 32) wks, [3000, 3500) g',
    risk_exposure_20211: 'Birth prevalence - [30, 32) wks, [3500, 4000) g',
    risk_exposure_20214: 'Birth prevalence - [32, 34) wks, [3000, 3500) g',
    risk_exposure_20215: 'Birth prevalence - [32, 34) wks, [3500, 4000) g',
    risk_exposure_20221: 'Birth prevalence - [36, 37) wks, [1000, 1500) g',
    risk_exposure_20224: 'Birth prevalence - [37, 38) wks, [1000, 1500) g',
    risk_exposure_20227: 'Birth prevalence - [38, 40) wks, [1000, 1500) g',
    risk_exposure_20228: 'Birth prevalence - [38, 40) wks, [1500, 2000) g',
    risk_exposure_20232: 'Birth prevalence - [40, 42) wks, [1500, 2000) g',
    risk_exposure_20944: 'Stage III chronic kidney disease annual exposure',
    risk_exposure_20945: 'Stage IV chronic kidney disease annual exposure',
    risk_exposure_20946: 'Stage V chronic kidney disease annual exposure',
    risk_exposure_20947: 'Albuminuria annual exposure',
    risk_exposure_20950: 'Female childhood sexual abuse annual exposure',
    risk_exposure_20951: 'Male childhood sexual abuse annual exposure',
    risk_exposure_20953: 'Proportion HIV due to intravenous drug use annual exposure',
    risk_exposure_20954: 'Proportion HIV due to sex annual exposure',
    risk_exposure_20955: 'Proportion HIV due to other annual exposure',
    risk_exposure_20960: 'Fraction of homicide against females due to IPV annual exposure',
    risk_exposure_20964: 'Diabetes mellitus annual exposure',
    risk_exposure_24370: 'Diet low in calcium (g/day) 25+',
    risk_exposure_24371: 'Diet low in fiber (g/day) 25+',
    risk_exposure_24372: 'Diet low in omega 3 (g/day) 25+',
    risk_exposure_24373: 'Diet low in fruit (g/day) 25+',
    risk_exposure_24374: 'Diet low in whole grains (g/day) 25+',
    risk_exposure_24375: 'Diet low in legumes (g/day) 25+',
    risk_exposure_24376: 'Diet low in milk (g/day) 25+',
    risk_exposure_24377: 'Diet low in nuts (g/day) 25+',
    risk_exposure_24378: 'Diet high in processed meat (g/day) 25+',
    risk_exposure_24379: 'Diet low in pufa (% energy/day) 25+',
    risk_exposure_24380: 'Diet high in red meat (g/day) 25+',
    risk_exposure_24381: 'Diet high in sodium (g/day) 25+',
    risk_exposure_24382: 'Diet high in ssbs (g/day) 25+',
    risk_exposure_24383: 'Diet high in transfat (% energy/day) 25+',
    risk_exposure_24384: 'Diet low in vegetables (g/day) 25+',
    risk_exposure_24745:
        'Particulate matter pollution shifted birth prevalence - [0, 24) wks, [500, 1000) g',
    risk_exposure_24746:
        'Particulate matter pollution shifted birth prevalence - [40, 42) wks, [1500, 2000) g',
    risk_exposure_24747:
        'Particulate matter pollution shifted birth prevalence - [40, 42) wks, [2000, 2500) g',
    risk_exposure_24748:
        'Particulate matter pollution shifted birth prevalence - [36, 37) wks, [1000, 1500) g',
    risk_exposure_24749:
        'Particulate matter pollution shifted birth prevalence - [38, 40) wks, [1000, 1500) g',
    risk_exposure_24750:
        'Particulate matter pollution shifted birth prevalence - [38, 40) wks, [2500, 3000) g',
    risk_exposure_24751:
        'Particulate matter pollution shifted birth prevalence - [32, 34) wks, [1500, 2000) g',
    risk_exposure_24752:
        'Particulate matter pollution shifted birth prevalence - [37, 38) wks, [4000, 4500) g',
    risk_exposure_24753:
        'Particulate matter pollution shifted birth prevalence - [28, 30) wks, [2000, 2500) g',
    risk_exposure_24754:
        'Particulate matter pollution shifted birth prevalence - [28, 30) wks, [2500, 3000) g',
    risk_exposure_24755:
        'Particulate matter pollution shifted birth prevalence - [34, 36) wks, [3000, 3500) g',
    risk_exposure_24756:
        'Particulate matter pollution shifted birth prevalence - [30, 32) wks, [3500, 4000) g',
    risk_exposure_24757:
        'Particulate matter pollution shifted birth prevalence - [34, 36) wks, [4000, 4500) g',
    risk_exposure_24758:
        'Particulate matter pollution shifted birth prevalence - [38, 40) wks, [3500, 4000) g',
    risk_exposure_24759:
        'Particulate matter pollution shifted birth prevalence - [40, 42) wks, [3500, 4000) g',
    risk_exposure_24760:
        'Particulate matter pollution shifted birth prevalence - [37, 38) wks, [3500, 4000) g',
    risk_exposure_24761:
        'Particulate matter pollution shifted birth prevalence - [34, 36) wks, [3500, 4000) g',
    risk_exposure_24762:
        'Particulate matter pollution shifted birth prevalence - [37, 38) wks, [3000, 3500) g',
    risk_exposure_24763:
        'Particulate matter pollution shifted birth prevalence - [36, 37) wks, [4000, 4500) g',
    risk_exposure_24764:
        'Particulate matter pollution shifted birth prevalence - [36, 37) wks, [3000, 3500) g',
    risk_exposure_24765:
        'Particulate matter pollution shifted birth prevalence - [28, 30) wks, [3000, 3500) g',
    risk_exposure_24766:
        'Particulate matter pollution shifted birth prevalence - [37, 38) wks, [2500, 3000) g',
    risk_exposure_24767:
        'Particulate matter pollution shifted birth prevalence - [26, 28) wks, [500, 1000) g',
    risk_exposure_24768:
        'Particulate matter pollution shifted birth prevalence - [38, 40) wks, [3000, 3500) g',
    risk_exposure_24769:
        'Particulate matter pollution shifted birth prevalence - [40, 42) wks, [3000, 3500) g',
    risk_exposure_24770:
        'Particulate matter pollution shifted birth prevalence - [36, 37) wks, [2500, 3000) g',
    risk_exposure_24771:
        'Particulate matter pollution shifted birth prevalence - [32, 34) wks, [2000, 2500) g',
    risk_exposure_24772:
        'Particulate matter pollution shifted birth prevalence - [28, 30) wks, [500, 1000) g',
    risk_exposure_24773:
        'Particulate matter pollution shifted birth prevalence - [30, 32) wks, [500, 1000) g',
    risk_exposure_24774:
        'Particulate matter pollution shifted birth prevalence - [32, 34) wks, [2500, 3000) g',
    risk_exposure_24775:
        'Particulate matter pollution shifted birth prevalence - [36, 37) wks, [3500, 4000) g',
    risk_exposure_24776:
        'Particulate matter pollution shifted birth prevalence - [38, 40) wks, [4000, 4500) g',
    risk_exposure_24777:
        'Particulate matter pollution shifted birth prevalence - [37, 38) wks, [2000, 2500) g',
    risk_exposure_24778:
        'Particulate matter pollution shifted birth prevalence - [32, 34) wks, [1000, 1500) g',
    risk_exposure_24779:
        'Particulate matter pollution shifted birth prevalence - [40, 42) wks, [4000, 4500) g',
    risk_exposure_24780:
        'Particulate matter pollution shifted birth prevalence - [28, 30) wks, [1000, 1500) g',
    risk_exposure_24781:
        'Particulate matter pollution shifted birth prevalence - [38, 40) wks, [1500, 2000) g',
    risk_exposure_24782:
        'Particulate matter pollution shifted birth prevalence - [34, 36) wks, [1500, 2000) g',
    risk_exposure_24783:
        'Particulate matter pollution shifted birth prevalence - [37, 38) wks, [1500, 2000) g',
    risk_exposure_24784:
        'Particulate matter pollution shifted birth prevalence - [30, 32) wks, [1000, 1500) g',
    risk_exposure_24785:
        'Particulate matter pollution shifted birth prevalence - [26, 28) wks, [1000, 1500) g',
    risk_exposure_24786:
        'Particulate matter pollution shifted birth prevalence - [24, 26) wks, [500, 1000) g',
    risk_exposure_24787:
        'Particulate matter pollution shifted birth prevalence - [30, 32) wks, [1500, 2000) g',
    risk_exposure_24788:
        'Particulate matter pollution shifted birth prevalence - [34, 36) wks, [1000, 1500) g',
    risk_exposure_24789:
        'Particulate matter pollution shifted birth prevalence - [30, 32) wks, [2000, 2500) g',
    risk_exposure_24790:
        'Particulate matter pollution shifted birth prevalence - [34, 36) wks, [2000, 2500) g',
    risk_exposure_24791:
        'Particulate matter pollution shifted birth prevalence - [32, 34) wks, [3000, 3500) g',
    risk_exposure_24792:
        'Particulate matter pollution shifted birth prevalence - [36, 37) wks, [1500, 2000) g',
    risk_exposure_24793:
        'Particulate matter pollution shifted birth prevalence - [28, 30) wks, [1500, 2000) g',
    risk_exposure_24794:
        'Particulate matter pollution shifted birth prevalence - [38, 40) wks, [2000, 2500) g',
    risk_exposure_24795:
        'Particulate matter pollution shifted birth prevalence - [0, 24) wks, [0, 500) g',
    risk_exposure_24796:
        'Particulate matter pollution shifted birth prevalence - [36, 37) wks, [2000, 2500) g',
    risk_exposure_24797:
        'Particulate matter pollution shifted birth prevalence - [40, 42) wks, [2500, 3000) g',
    risk_exposure_24798:
        'Particulate matter pollution shifted birth prevalence - [32, 34) wks, [3500, 4000) g',
    risk_exposure_24799:
        'Particulate matter pollution shifted birth prevalence - [30, 32) wks, [2500, 3000) g',
    risk_exposure_24800:
        'Particulate matter pollution shifted birth prevalence - [30, 32) wks, [3000, 3500) g',
    risk_exposure_24801:
        'Particulate matter pollution shifted birth prevalence - [34, 36) wks, [2500, 3000) g',
    risk_exposure_24812: 'Back-transformed proportion HIV due to sex',
    risk_exposure_25052:
        'Particulate matter pollution shifted birth prevalence - [37, 38) wks, [1000, 1500) g',
};
